import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import ContactUs from "./components/ContactUs/ContactUs";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Aboutus from "./components/Aboutus/Aboutus";
import TermsCondition_User from "./components/PrivacyPolicy/TermsCondition_User";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";
import TermsCondition_SSI from "./components/PrivacyPolicy/TermsCondition_SSI/TermsCondition_SSI";

function App() {
  // const scrollToSection = (sectionId) => {
  //   const section = document.getElementById(sectionId);
  //   console.log(section);
  //   if (section) {
  //     section.scrollIntoView({ behavior: "smooth", block: "start" });
  //   }
  // };
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/terms&conditions" element={<TermsCondition_User />} />

        <Route path="/terms&conditions-ssi" element={<TermsCondition_SSI />} />
        <Route path="/aboutus" element={<Aboutus />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
